import { defineMessages } from "react-intl";

export default defineMessages({
  genetiivi: {
    id: "ammatillinenKoulutus.genetiivi",
    defaultMessage: "Ammatillisen koulutuksen"
  },
  kebabCase: {
    id: "ammatillinenKoulutus.kebabCase",
    defaultMessage: "ammatillinen-koulutus"
  },
  kuvausteksti: {
    id: "ammatillinenKoulutus.kuvausteksti",
    defaultMessage:
      "Ammatillisten tutkintojen ja koulutuksen järjestäminen edellyttää opetus ja kulttuuriministeriön myöntämää tutkintojen ja koulutuksen järjestämislupaa. Järjestämislupa voidaan myöntää hakemuksesta kunnalle, kuntayhtymälle, rekisteröidylle yhteisölle tai säätiölle. Tällä sivulla voit tarkastella koulutuksen järjestäjiä ja niiden järjestämislupia."
  },
  lyhytKuvaus: {
    id: "ammatillinenKoulutus.lyhytKuvaus",
    defaultMessage:
      "Ammatillisten tutkintojen ja koulutuksen järjestäminen edellyttää opetus ja kulttuuriministeriön myöntämää tutkintojen ja koulutuksen järjestämislupaa. Järjestämislupa voidaan myöntää hakemuksesta kunnalle, kuntayhtymälle, rekisteröidylle yhteisölle tai säätiölle. Tällä sivulla voit tarkastella koulutuksen järjestäjiä ja niiden järjestämislupia."
  },
  paasivunOtsikko: {
    id: "ammatillinenKoulutus.paasivunOtsikko",
    defaultMessage: "Ammatillisen koulutuksen järjestäjät"
  },
  jarjestamislupa: {
    id: "ammatillinenKoulutus.jarjestamislupa",
    defaultMessage: "Ammatillisen koulutuksen järjestämislupa"
  }
});
